module.exports = "../images/logo-typography.png";